module.exports = __webpack_public_path__ + "static/media/IMG_5881.983d4c7f.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_5881.PNG
// module id = 1127
// module chunks = 0 1